define('webshopLandingpagesListHeaderToolsView',[
  'app',
  'module',
  'settings',
  'underscore',
  'orderUtils',
  'buttonView',
  'tableHeaderFieldView',
  'webshopLandingpagesDetailView',
  'template!webshopLandingpagesListHeaderToolsView'
], function (
  App,
  Module,
  Settings,
  _,
  OrderUtils,
  ButtonView,
  FieldView,
  DetailView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'webshop-landingpages-header-tools-view ' + FieldView.prototype.className,

    regions: {
      addRegion: '.add-region'
    },

    onRender: function() {     
      this.addButtonView = new ButtonView({
        type: 'add',
        color: 'orange',
        text: _.i18n('landingpages.createNew'),
        title: _.i18n('landingpages.createNew')
      });

      this.addRegion.show(this.addButtonView);
      this.addButtonView.on('click', _.bind(this.options.tableView.onAdd, this.options.tableView));
    }
  });
});
